import { createI18n } from 'vue-i18n'
import languagesConfig from '@/config/languagesConfig.json'
//
import en from './locales/en.json'
import es from './locales/es.json'
import ca from './locales/es-ca.json'
import eu from './locales/es-eu.json'


const savedLang = localStorage.getItem('languageSetup') ?? languagesConfig.defaultLanguage

const configI18n = {
    legacy: false,
    globalInjection: true,
    locale: savedLang,
    fallbackLocale: languagesConfig.fallbackLocale,
    messages: {
        es, en, ca, eu
    },
    silentTranslationWarn: true,
    fallbackWarn: false,
    missingWarn: false
}

// Create Vue I18n instance.
export const i18n = createI18n(configI18n)


export const translate = (key) => {
    if (!key) {
        return '';
    }
    return i18n.global.t(key);
};


